import React, { useState, useEffect, useCallback } from "react";
import { useInvoiceContext, useControlContext } from "../context";
import { Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faWarning,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { emailValidation } from "../utils";
import ButtonNext from "./ButtonNext";
import CardResume from "./CardResume";

function FormEmail(props) {
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [showResumo, setShowResumo] = useState(false);

  const { customer, setFieldCustomer } = useInvoiceContext();
  const { setProgressViewerEmail, setActiveFormEmail } = useControlContext();

  const { active, handleNext } = props;

  const isInvalidDomain = (email) => {
    const domain = email.substring(email.lastIndexOf("@") + 1);
    return (
      domain === "sharmaq.com.br" ||
      domain === "sharmaq.com" ||
      domain === "shoficina.com.br" ||
      domain === "shoficina.com"
    );
  };

  const validateForm = useCallback(() => {
    if (
      emailValidation(customer.email) &&
      customer.email !== customer.confirm_email &&
      emailValidation(customer.confirm_email)
    ) {
      setErrors((errors) => ({
        ...errors,
        confirmEmail: "Os emails não conferem",
      }));
    }

    if (isInvalidDomain(customer.email)) {
      setErrors((errors) => ({
        ...errors,
        confirmEmail: "O domínio do email não é permitido",
      }));
    }

    if (
      emailValidation(customer.email) &&
      customer.email === customer.confirm_email &&
      !isInvalidDomain(customer.email)
    ) {
      setDisabled(false);
      return true;
    } else {
      setDisabled(true);
      return false;
    }
  }, [customer, setErrors]);

  const setField = (field, value) => {
    value = value.toLowerCase();
    setFieldCustomer(field, value);
    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const next = () => {
    if (validateForm()) {
      setShowResumo(true);
      handleNext();
      setProgressViewerEmail(true);
    }
  };

  const edit = () => {
    setActiveFormEmail(true);
    setShowResumo(false);
  };

  useEffect(() => {
    validateForm();
  }, [customer, validateForm]);

  const styles = {
    infoTitle: {
      fontSize: "1.2em",
      color: "#d9534f",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    },
    infoText: {
      fontSize: "0.8em",
      color: "#444e55",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    },
  };

  return (
    <div className="position-relative">
      <Card hidden={!active} border="primary mb-2">
        <Card.Body>
          <Card.Subtitle>E-mail de Registro</Card.Subtitle>
          <p style={styles.infoText}>
            <FontAwesomeIcon icon={faWarning} color="#d9534f" />{" "}
            <strong style={styles.infoTitle}>Atenção:</strong> O e-mail
            informado será utilizado para envio da{" "}
            <strong>nota fiscal eletrônica</strong> e de sua{" "}
            <strong>licença de uso</strong>, portanto, deve ser válido e de uso
            exclusivo do cliente.
          </p>
          <Form>
            <div className="form-group mb-2">
              <label>E-mail</label>
              <Form.Control
                size="sm"
                type="email"
                placeholder="E-mail"
                name="email"
                value={customer.email}
                onChange={(e) => setField("email", e.target.value)}
                isValid={
                  customer.email.length > 3 && emailValidation(customer.email)
                }
                isInvalid={
                  (customer.email.length > 3 &&
                    !emailValidation(customer.email)) ||
                  isInvalidDomain(customer.email)
                }
              />
              <Form.Control.Feedback type="invalid">
                Digite um e-mail válido
              </Form.Control.Feedback>

              <label>Confirme o E-mail</label>
              <Form.Control
                size="sm"
                type="email"
                placeholder="Confirme o E-mail"
                name="confirmEmail"
                value={customer.confirm_email}
                onChange={(e) => setField("confirm_email", e.target.value)}
                onPaste={(e) => e.preventDefault()}
                isValid={
                  customer.confirm_email.length > 3 &&
                  emailValidation(customer.confirm_email) &&
                  customer.confirm_email === customer.email
                }
                isInvalid={
                  (emailValidation(customer.email) &&
                    !emailValidation(customer.confirm_email)) ||
                  (customer.confirm_email.length > 3 &&
                    customer.confirm_email !== customer.email) ||
                  (customer.confirm_email.length > 3 &&
                    !emailValidation(customer.confirm_email)) ||
                  isInvalidDomain(customer.email)
                }
              />
              <Form.Control.Feedback type="invalid">
                {errors.confirmEmail}
              </Form.Control.Feedback>
            </div>
            <ButtonNext
              className="float-end"
              variant="primary"
              text="Próximo"
              faicon={faArrowRight}
              disabled={disabled}
              onClick={next}
            />
          </Form>
        </Card.Body>
      </Card>
      <CardResume
        show={(!active && showResumo) || showResumo}
        handleEdit={edit}
        title="Será enviado
            para o e-mail:"
        icon={faEnvelope}
      >
        {customer.email} <br />
      </CardResume>
    </div>
  );
}

export default FormEmail;
